module.exports = __webpack_public_path__ + "ac7d2f952e41b55da95101cb1ecd6e5e.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-34.cur
// module id = 453
// module chunks = 0